import { useState, useEffect, Fragment, CSSProperties } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import CustomRadioBtn from "../../base/CustomRadioBtn";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as AddFileImg } from '../../../img/ico-prefix-add-file.svg';
import { ReactComponent as UrlImg } from '../../../img/ico-prefix-url.svg';
import { ReactComponent as StatusStableImg} from "../../../img/ico-status-stable.svg";
import { ReactComponent as StatusBlockImg } from "../../../img/ico-status-block.svg";
import { ReactComponent as TableEditImg } from '../../../img/ico-table-edit.svg';

import { useTranslation } from "react-i18next";
import { CustomImgBtn } from "../../base/CustomImgBtn";
import { CustomCircleCheckBox } from "../../base/CustomCheckBox";
import { actionMenusDetail, RouterDetailData } from "./RouterData";
import { parseLocaleDatetime } from "common/util";
import ListTable from "components/base/table/listTable";
import ContentBox from "components/base/tamplate/ContentBox";
import { ContentContainerProps } from "interfaceTypes/ContentsProps";
import { HostClusterTableData } from "./RouterDetailData";

interface RouterDetailProps extends ContentContainerProps{
    clickActionMenu: Function;
    selectRow: Function;
    updateFunction: Function;
    pageCount: number;
    headers: any;
    totalItemCount: number;
    refreshYn: boolean;
    loadMainDataYn: boolean;
    tableData: HostClusterTableData[];
    detailData: RouterDetailData;
};

RouterDetail.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function RouterDetail(props:RouterDetailProps) {
    const { t } = useTranslation();

    return (
        <ContentBox title={t("ROUTER_DETAIL_TITLE")} subtitle={t("ROUTER_DETAIL_SUBTITLE")} infoText={props.infoText} infoError={props.infoError} back={true} >
            <View style={style.topContainer}>
                <View style={{
                    flexDirection: "row", alignItems: "center", justifyContent: "flex-end"
                }}>
                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                        <Text style={style.dateTitle}>
                            {t("LAST_UPDATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.update_ts ? parseLocaleDatetime(props.detailData.update_ts) : ""}
                        </Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "center", marginLeft: 30 }}>
                        <Text style={style.dateTitle}>
                            {t("CREATE_DATE_TEXT")}
                        </Text>
                        <Text style={style.dateData}>
                            {props.detailData.create_ts ? parseLocaleDatetime(props.detailData.create_ts) : ""}
                        </Text>
                    </View>
                </View>

                <View style={{...style.boxContainer, height: 310}}>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 50}}>
                        <Text style={style.boxContentTitle}>
                            {t("BASE_INFO_TEXT")}
                        </Text>
                        <div 
                            style={{display: "flex", alignItems: "center", marginLeft: "auto", cursor: "pointer"}}
                            onClick={() => {
                                props.updateFunction();
                            }}
                        >
                            <TableEditImg/>
                            <Text style={{
                                marginLeft: 2,
                                fontFamily: FONT.MEDIUM,
                                fontSize: 12,
                                color: "#3c5df2"
                            }}>
                                {t("INFO_EDIT_TEXT")}
                            </Text>
                        </div>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                        <Text style={style.boxContentHeaderText}>
                            {t("ROUTER_NAME_TEXT")}
                        </Text>
                        <Text style={{...style.boxContentDataText,fontFamily: FONT.MEDIUM, fontSize: 14, marginRight: 14}}>
                            {props.detailData.router_name}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                        <Text style={style.boxContentHeaderText}>
                            {t("DESCRIPTION_TEXT")}
                        </Text>
                        <Text style={style.boxContentDataText}>
                            {props.detailData.router_description || "-"}
                        </Text>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("PROJECT_NAME_TEXT")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData.project.project_name || "-"}
                                </Text>
                            </View>
                        </View>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("ROUTER_TABLE_COLUMN_ROUTER_NETWORK")}
                                </Text>
                                <Text style={style.boxContentDataText}>
                                    {props.detailData.network.network_name || "-"}
                                </Text>
                            </View>
                        </View>
                    </View>
                    <View style={{flexDirection: "row"}}>
                        <View style={{width: 490}}>
                            <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>

                                <Text style={style.boxContentHeaderText}>
                                    {t("ROUTER_TABLE_COLUMN_ROUTER_UP_MODE")}
                                </Text>
                                <div style={{
                                    display: "flex", alignItems: "center",
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: props.detailData.up_yn ? "#3a8344" : "#8c8c8c",
                                }}>
                                    {
                                        props.detailData.up_yn ? <StatusStableImg/> : <StatusBlockImg/>
                                    }
                                    {
                                        props.detailData.up_yn ? "Up" : "Down"
                                    }
                                </div>
                            </View>
                        </View>
                        <View style={{width: 490}}>
                        <View style={{flexDirection: "row", alignItems: "center", marginBottom: 30}}>
                            <Text style={style.boxContentHeaderText}>
                                {t("ROUTER_TABLE_COLUMN_ROUTER_HA_MODE")}
                            </Text>
                            <Text style={style.boxContentDataText}>
                                {props.detailData.ha_yn ? <StatusStableImg/> : <StatusBlockImg/>}
                            </Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={{...style.boxContainer, height: 720}}>
                    <View style={{flexDirection: "row", alignItems: "center"}}>
                        <Text style={{...style.boxContentTitle, fontFamily: FONT.REGULAR, color: "#3a3b3f"}}>
                            {t("NETWORK_PORT_TEXT")}
                        </Text>
                    </View>
                    <View style={{marginTop: 24}}>
                        <ListTable
                            id={"routerPortList"}
                            actionMenus={actionMenusDetail}
                            actionMenuClickCb={props.clickActionMenu}
                            searchBarYn={false}
                            pageYn={true}
                            rowCheckYn={true}
                            rowCheckCb={props.selectRow}
                            fetchDataCb={()=>{}}
                            pageCount={props.pageCount}
                            pageSize={20}
                            tableHeaders={props.headers}
                            tableData={props.tableData}
                            totalItemCount={props.totalItemCount}
                            detailYn={false}
                            refreshYn={props.refreshYn}
                            canLoadYn={true}
                        />
                    </View>
                </View>
            </View>
        </ContentBox>
    );
}


const style = StyleSheet.create({
    topContainer: {
        width: 1115,
        minHeight: 860,
    },
    boxContainer: {
        marginTop: 20,
        paddingTop: 34, paddingLeft: 50, paddingRight: 40, paddingBottom: 45,
        borderRadius: 8,
        boxShadow: "0 10px 12px 0 rgba(63, 63, 68, 0.05), 0 1px 3px 0 rgba(0, 0, 0, 0.05)",
        borderStyle: "solid", borderWidth: 1, borderColor: "#e5e9ec",
        backgroundColor: "#fff"
    },
    dateTitle: {
        marginRight: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 10,
        color: "#8793a3"
    },
    dateData: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    },
    boxContentTitle: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333"
    },
    boxContentHeaderText: {
        width: 130,
        marginRight: 52,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        lineHeight: 12,
        color: "#333"
    },
    boxContentDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    boxContentBlueDataText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#0853fb"
    }
});